import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-card-docenti',
  templateUrl: './sample-card-docenti.component.html',
  styleUrls: ['./sample-card-docenti.component.scss']
})
export class SampleCardDocentiComponent implements OnInit {

  @Input() block: any;
  public domainWebsite = environment.urlApi;
  public imgPath = '';
  public imgPathExport = '';
  public linkPageDocente = '';

  constructor(private helperService: HelpersService) { }

  ngOnInit(): void {
    this.setRetriveField();
  }

  private setRetriveField() {
    if (this.block && !this.block.length && this.block.title) {
      this.linkPageDocente = this.helperService.retriveLinkTagA(this.block.title, 'a').link;
    } else {
      this.linkPageDocente = this.helperService.retriveLinkTagA(this.block.field_titolo, 'a').link;
    }

    if (this.block && !this.block.length && this.block.field_foto) {
      this.imgPath = this.domainWebsite + this.helperService.retrieveImage(this.block.field_foto, 'src');
    } else {
      this.imgPathExport = '';
    }
  }

  public retriveImage(imgPath: string): string {
    return this.domainWebsite + this.helperService.retrieveImage(imgPath, 'src');
  }

  public retriveUrl(data: string): any {
    const retriveItem = data.match(/\/(it|en)(.*)/);
    return retriveItem ? retriveItem[2] : '';
  }

  public retriveEmail(email: string): any {
    let mail;
    if (email && email.match(/href=['"]?mailto:(.*?)['" ]/i)) {
      mail = email.match(/href=['"]?mailto:(.*?)['" ]/i);
    }
    return mail ? mail[1] : '';
  }

}